<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (accessLoader) {
<div class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
}
@if (user_type=='cdm') {
<div class="card">
	<div class="card-body">
		<h2 class="card-title">
			{{pagetitle}}
		</h2>
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-3">
				<div class="col">
					<ng-select [items]="vessels" bindLabel="name" bindValue="id" [typeahead]="vesselSearchInput$"
						[loading]="loadingVessels" [virtualScroll]="true" [minTermLength]="2"
						(scrollToEnd)="loadMoreVessels()" placeholder="*Vessels" [clearable]="true" [multiple]="true"
						formControlName="id" id="id" appearance="outline" [closeOnSelect]="false">
					</ng-select>
					@if (showError('id')) {
					<p class="text-danger">
						<span>
							@if (f.id.errors?.required) {
							Required
							}
							@if (f.id.errors?.incorrect) {
							{{customError.id}}
							}
						</span>
					</p>
					}
				</div>
			</div>
			<div class="row mb-3">
				<div class="col">
					<ng-select [items]="companies" bindLabel="name" bindValue="id" [loading]="loadingCompanies"
						placeholder="*Companies" [clearable]="true" [multiple]="true" formControlName="company"
						id="company" appearance="outline" [closeOnSelect]="false">
					</ng-select>
					@if (showError('company')) {
					<p class="text-danger">
						<span>
							@if (f.company.errors?.required) {
							Required
							}
							@if (f.company.errors?.incorrect) {
							{{customError.company}}
							}
						</span>
					</p>
					}
				</div>
			</div>
			<div class="row mb-3">
				<div class="col text-center">
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<fa-icon [icon]="['fas', 'sync']" [animation]="showLoader?'spin':undefined"></fa-icon>
						Sync
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/vessel']">
						Cancel
					</a>
				</div>
			</div>
		</form>
	</div>
</div>
}@else {
<h3 class="text-center">You don't have access to this section.</h3>
}